import React from 'react';
import { InputFieldWithTitles } from '../../../../../../components/UI-Elements/Select/InputFieldWithTitles';
import { OptionSelect } from '../../../../../../components/UI-Elements/Select/OptionSelect';
import { useProductCategories } from '../../../../../../hooks/useProducts';
import { MeasureType, Product, ProductMeasureTypes } from '../../../../../../sp-types/productType';

interface Props {
  product: Product;
  setProduct: React.Dispatch<React.SetStateAction<Product>>;
  isEditable?: boolean;
}

export const ProductModifyInputFields: React.FC<Props> = ({ product, setProduct, isEditable = true }) => {
  const { data: productCategories } = useProductCategories();

  return (
    <div className="flex flex-col gap-2">
      <h6 className="text-red text-lg">Product</h6>
      <div className="flex flex-row gap-5">
        <div className="w-[6rem]">
          <InputFieldWithTitles
            subtitle="Product ID"
            placeHolder="Add ID"
            isEditable={isEditable}
            changeValueFunc={(value: string | number) => setProduct({ ...product, id: value.toString() })}
            value={product.id}
          />
        </div>
        <div className="w-[15rem] ">
          <InputFieldWithTitles
            subtitle="Product name"
            placeHolder="set product name"
            isEditable={isEditable}
            changeValueFunc={(value: string | number) => setProduct({ ...product, name: value.toString() })}
            value={product.name}
          />
        </div>
        <div className="w-[8rem]">
          <OptionSelect
            placeHolder="Set measure type"
            disabled={!isEditable}
            isEditable={isEditable}
            currentOption={product.measureType}
            options={ProductMeasureTypes.map((item) => item)}
            setCurrentOption={(measureType: string) => {
              setProduct({ ...product, measureType: measureType as MeasureType });
            }}
            subtitle="measure type"
          />
        </div>
        {productCategories && (
          <>
            <div className="w-[12rem]">
              <OptionSelect
                placeHolder="Set Category"
                disabled={!isEditable}
                isEditable={isEditable}
                currentOption={product.category}
                options={productCategories.map((item) => item.name)}
                setCurrentOption={(value: string) => {
                  setProduct({ ...product, category: value, subCategory: '' });
                }}
                subtitle="Category"
              />
            </div>
            {product.category && productCategories.map((item) => item.name).includes(product.category) && (
              <div className="w-[12rem]">
                <OptionSelect
                  placeHolder="Set sub category"
                  disabled={!isEditable}
                  isEditable={isEditable}
                  currentOption={product.subCategory}
                  options={
                    productCategories
                      .find((item) => item.name === product.category)
                      ?.subCategories.map((item) => item) || []
                  }
                  setCurrentOption={(value: string) => {
                    setProduct({ ...product, subCategory: value });
                  }}
                  subtitle="Sub Category"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
